// extracted by mini-css-extract-plugin
export default {"accordionHeading":"EMPAccordionLincoln_accordionHeading__f-XV8"};